import { param } from 'jquery'
import service from './base'
// 创建订单
export function creatOrderApi(data) {
    return service({
      url: `/ask/customer/api/v1/order/create-order`,
      method: 'POST',
      data
    })
  }
  // 查询历史订单
  export function getAskHistoryApi(params) {
    return service({
      url: `/ask/customer/api/v1/order/ask-history`,
      method: 'GET',
      params
    })
  }
  // 查询订单列表
  export function getAskOrderListApi(data) {
    return service({
      url: `/ask/customer/api/v1/order/query-order-list`,
      method: 'POST',
      data
    })
  }
  // 查询订单详情
  export function getAskOrderDetailApi(params) {
    return service({
      url: `/ask/customer/api/v1/order/query-order-info`,
      method: 'GET',
      params
    })
  }
  // 获取支付参数
  export function getPaymentSignApi(data) {
    return service({
      url: `/ask/customer/api/v1/order/get-payment-sign`,
      method: 'post',
      data
    })
  }
  // 上传补充信息
  export function uploadSupplementApi(data) {
    return service({
      url: `/ask/customer/api/v1/order/upload/supplementary-information`,
      method: 'post',
      data
    })
  }
  // 催促回复
  export function urgeReplyApi(data) {
    return service({
      url: `/ask/customer/api/v1/order/request-replay`,
      method: 'post',
      data
    })
  }
  // 提交订单评价
  export function submitOrderCommentApi(data) {
    return service({
      url: `/ask/customer/api/v1/order/submit`,
      method: 'post',
      data
    })
  }
  // 取消订单
  export function cancelOrderApi(data) {
    return service({
      url: `/ask/customer/api/v1/order/cancel-order`,
      method: 'post',
      data
    })
  }
  //删除订单
  export function deleteOrderApi(data) {
    return service({
      url: `/ask/customer/api/v1/order/delete-order`,
      method: 'delete',
      data,
      params: data
    })
  }
  // 查询订单中是否有未读消息
  export function getOrderUnreadMessageApi(data) {
    return service({
      url: `/ask/patient/api/v1/contact-info/query-has-unread-message`,
      method: 'get',
      params: data
    })
  }
  // 提交预问诊问卷
  export function submitQuestionnaireApi(data) {
    return service({
      url: `/ask/customer/api/v1/order/fill-pre-consultation-questionnaire`,
      method: 'post',
      data: data
    })
  }
  // 患者主动补充资料
  export function patientSupplementInfoApi(data) {
    return service({
      url: `/ask/customer/api/v1/order/patient-supplement-info`,
      method: 'post',
      data: data
    })
  }
